var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMenuMoreWellnessScore = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20.41 20.06",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.1,1.31A9,9,0,1,1,1.82,12.86",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0399999618530273px"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.54,10.31V6.4l-.89.91L0,6.62l1.69-1.7h1V10.3H1.54Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93,10.31v-.9c2.2-1.62,2.85-2.18,2.85-2.84,0-.47-.43-.7-.88-.7a1.94,1.94,0,0,0-1.44.62l-.65-.76a2.73,2.73,0,0,1,2.07-.88A1.83,1.83,0,0,1,7.94,6.57c0,.92-.76,1.72-2.2,2.74H8v1H3.93Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47,8.8A2.12,2.12,0,0,0,11,9.41c.65,0,1-.28,1-.69s-.33-.64-1.08-.64h-.67v-1h.67c.6,0,1-.19,1-.6s-.44-.65-1-.65a2,2,0,0,0-1.37.56l-.57-.71A2.66,2.66,0,0,1,11,4.82c1.26,0,2,.56,2,1.46a1.33,1.33,0,0,1-1.18,1.23A1.35,1.35,0,0,1,13.11,8.8c0,.93-.83,1.58-2.12,1.58a2.69,2.69,0,0,1-2.12-.86l.6-.75Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuMoreWellnessScore, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Menu_More_Wellness_Score.09130044.svg";
export { ForwardRef as ReactComponent };